export default {
	main_toolbar_search_placeholder: 'Suche...',
};
